<script context="module">
  import { NAMES } from '../utils'

  export { NAMES }
</script>

<script>
  import { getClass } from '../utils'

  import appStoreIcon from './_assets/appstore.svg'
  import googlePlayIcon from './_assets/googleplay.svg'

  export let name
  export let href

  $: className = getClass({ className: $$props.class || '' })
</script>

<a {href} {...$$restProps} target="_blank" class={className}>
  {#if name === NAMES.APP_STORE}
    {@html appStoreIcon}
  {:else if name === NAMES.GOOGLE_PLAY}
    {@html googlePlayIcon}
  {/if}
</a>
